











import Vue, { PropType } from 'vue';

interface DataType {
  tabLinks: object[];
  tabOptions: object[];
  headingTexts: object[];
}

export default Vue.extend({
  name: 'GAccountHeader',
  props: {
    buttons: {
      type: Array as PropType<object[]>,
      default: () => [],
    },
    isInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    currentPage: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data(): DataType {
    return {
      headingTexts: [{ text: 'アカウント' }],
      tabLinks: [
        { text: 'アカウント情報', to: { name: 'exhibitor-account-edit', query: { page: 'top' } } },
        { text: '担当者情報', to: { name: 'exhibitor-account-edit', query: { page: 'user' } } },
        { text: '企業情報', to: { name: 'exhibitor-account-edit', query: { page: 'company' } } },
      ],
      tabOptions: [
        { value: 0, text: 'アカウント情報', to: { name: 'exhibitor-account-edit', query: { page: 'top' } } },
        { value: 1, text: '担当者情報', to: { name: 'exhibitor-account-edit', query: { page: 'user' } } },
        { value: 2, text: '企業情報', to: { name: 'exhibitor-account-edit', query: { page: 'company' } } },
      ],
    };
  },
});
